export default {
    keyword(state) {
        return state.keyword;
    },
    bannedWord(state) {
        return state.bannedWord;
    },
    keywordTagTypes(state) {
        return state.keywordTagTypes;
    },
    keywordTags(state) {
        return state.keywordTags; // Vuex state'teki keywordTags verisini döndür
    },
    keywordForSelect(state) {
        const keywords = [];

        for (const index in state.keyword) {
            const keywordItem = {
                id: state.keyword[index].id,
                text: state.keyword[index].text
            }

            keywords.push(keywordItem);
        }

        return keywords;
    },
    keywordVariation(state) {
        return state.variationVal;
    },

    keywordSource(state) {
        return state.sourceVal;
    },

    keywordSourceOptions(state) {
        return state.sourceOptions;
    }
    ,

    KeywordDetail(state) {
        return state.KeywordDetail;
    }


}